import React, { useState } from 'react';
import { Loader2, Plus, X } from 'lucide-react';
import { moduleApi } from '../../lib/api';
import { Input } from '../ui/Field';
import { type PrestationCategory } from './prestationsTypes';

export function CategoryManager({ categories, onChanged }: { categories: PrestationCategory[]; onChanged: () => void }) {
    const [newName, setNewName] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const add = async () => {
        const name = newName.trim();
        if (!name) return;
        setSaving(true); setError('');
        try {
            const res: any = await moduleApi.createPrestationCategory(name);
            if (res?.error) { setError(res.error); return; }
            setNewName(''); onChanged();
        } catch (e: any) {
            setError(e?.message || 'Erreur');
        } finally {
            setSaving(false);
        }
    };
    const remove = async (id: string) => {
        try { await moduleApi.deletePrestationCategory(id); onChanged(); } catch (e) {}
    };

    return (
        <div className="p-3 rounded-xl bg-surface-soft/60 border border-border space-y-2">
            <p className="text-[10px] font-bold text-content-muted uppercase tracking-widest">Catégories de prestations</p>
            <p className="text-[11px] text-content-muted">Regroupent plusieurs prestations (ex: chaise tissu, osier, fauteuil...) sous un même seuil — assignez la catégorie à chaque prestation du catalogue ci-dessus.</p>
            {error && <p className="text-[11px] text-red-500">{error}</p>}
            {categories.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                    {categories.map((cat) => (
                        <span key={cat.id} className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-lg bg-surface border border-border text-content">
                            {cat.name}
                            <button type="button" onClick={() => remove(cat.id)} className="text-content-muted hover:text-red-400"><X size={11} /></button>
                        </span>
                    ))}
                </div>
            )}
            <div className="flex items-center gap-2">
                <input type="text" value={newName} onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()}
                    placeholder="Ex: Assise, Textile..." className="flex-1 bg-surface border border-border rounded-lg px-2.5 py-1.5 text-xs text-content outline-none focus:border-brand-500" />
                <button type="button" onClick={add} disabled={saving || !newName.trim()}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-brand-600 hover:bg-brand-700 text-brand-fg text-xs font-bold shrink-0 disabled:opacity-40 disabled:bg-surface disabled:text-content-muted disabled:border disabled:border-border">
                    {saving ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} Ajouter
                </button>
            </div>
        </div>
    );
}

